var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22748 16.7734C6.93459 16.4805 6.93459 16.0057 7.22748 15.7128L15.7128 7.22748C16.0057 6.93459 16.4805 6.93459 16.7734 7.22748C17.0663 7.52038 17.0663 7.99525 16.7734 8.28814L8.28814 16.7734C7.99525 17.0663 7.52038 17.0663 7.22748 16.7734Z",
    fill: "#89C0E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22748 7.22748C7.52038 6.93459 7.99525 6.93459 8.28814 7.22748L16.7734 15.7128C17.0663 16.0057 17.0663 16.4805 16.7734 16.7734C16.4805 17.0663 16.0057 17.0663 15.7128 16.7734L7.22748 8.28814C6.93459 7.99525 6.93459 7.52038 7.22748 7.22748Z",
    fill: "#89C0E9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDocument);
export default __webpack_public_path__ + "static/media/delete_document.f4ada99b8c176acda3e040411791284f.svg";
export { ForwardRef as ReactComponent };